<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="width:40%; padding-left: 15px;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Order Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.loadingordernum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.loadingorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Status</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.loadingorderstatus }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.loadingordertype }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Loading Location</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ data_location }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.loadingordername }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold;">Vehicle</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_vehicle }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Driver</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_driver }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Loader</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_loader }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 15px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th colspan="2" style="text-align: center;">&nbsp;</th>
            <th colspan="2" style="text-align: center; font-size: small;">LOADING</th>
            <th colspan="2" style="text-align: center; font-size: small;">SALES ORDERS</th>
            <th colspan="2" style="text-align: center; font-size: small;">BALANCE</th>
          </tr>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;">#</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Item</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in getLoadingList()"  v-bind:key="trans._id">
            <td style="padding-top: 2px; padding-bottom: 2px;">{{ index + 1 }}</td>
            <td>{{ data_company!=null && data_company.items.length>0 ? data_company.items.find(item=>item._id == trans.itemid)['itemsalesdesc'] : '' }}</td>
            <td style="text-align: center;">{{ getQuantity(trans.itemid, trans.itemquantity) }}</td>
            <td style="text-align: center;">{{ getPieces(trans.itemid, trans.itemquantity) }}</td>
            <td style="text-align: center;">{{ getQuantity(trans.itemid, getSalesQuantity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getPieces(trans.itemid, getSalesQuantity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getQuantity(trans.itemid, getBalanceQuanity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getPieces(trans.itemid, getBalanceQuanity(trans.itemid)) }}</td>
          </tr>
          <tr>
            <td colspan="8" style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;"></td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
      <table v-if="initvalue.loadingorderstatus=='Unloaded'" style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th colspan="2" style="text-align: left;">Unloading&nbsp;</th>
            <th colspan="2" style="text-align: center; font-size: small;">UNLOADING COUNT</th>
            <th colspan="2" style="text-align: center; font-size: small;">BALANCE</th>
            <th colspan="2" style="text-align: center; font-size: small;">DIFFERENCE</th>
          </tr>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;">#</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Item</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Qty</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;text-align: center;">Pcs</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in getLoadingList()"  v-bind:key="trans._id">
            <td style="padding-top: 2px; padding-bottom: 2px;">{{ index + 1 }}</td>
            <td>{{ data_company!=null && data_company.items.length>0 ? data_company.items.find(item=>item._id == trans.itemid)['itemsalesdesc'] : '' }}</td>
            <td style="text-align: center;">{{ getQuantity(trans.itemid, getUnloadingQuantity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getPieces(trans.itemid, getUnloadingQuantity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getQuantity(trans.itemid, getBalanceQuanity(trans.itemid)) }}</td>
            <td style="text-align: center;">{{ getPieces(trans.itemid, getBalanceQuanity(trans.itemid)) }}</td>
            <td style="text-align: center; color: red; font-weight: bold;">{{ getQuantity(trans.itemid, getDifferenceQuantity(trans.itemid)) }}</td>
            <td style="text-align: center; color: red; font-weight: bold;">{{ getPieces(trans.itemid, getDifferenceQuantity(trans.itemid)) }}</td>
          </tr>
          <tr>
            <td colspan="8" style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;"></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td colspan="2" style="text-align: center; font-size: large; font-weight: bold;">{{ getUnloadingQuantityTotal() }}</td>
            <td colspan="2" style="text-align: center; font-size: large; font-weight: bold;">{{ getBalanceQuanityTotal() }}</td>
            <td colspan="2" style="text-align: center; color: red; font-size: large; font-weight: bold;">{{ getUnloadingQuantityTotal() - getBalanceQuanityTotal() }}</td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
      <table cellpadding="0" cellspacing="0">
        <tr>
          <td v-if="load_image!=null"><img :src="load_image.imageurl??''" alt="Loading" style="max-height: 300px; margin-right: 10px;"><p>{{ load_image.imagename??''}}</p></td>
          <td v-if="unload_image!=null"><img :src="unload_image.imageurl??''" alt="Unloading" style="max-height: 300px; margin-right: 10px;"><p>{{ unload_image.imagename??''}}</p></td>
        </tr>
      </table>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintLoadingOrder',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      transactions: [],
      load_image: null,
      unload_image: null,
      sales: [],
      data_company: null,
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getLoadingOrderRequest', 'getCompanyDataRequest']),
    groupBy(array) {
      var result = [];
      array.reduce(function(res, value) {
        if (!res[value.itemid]) {
          res[value.itemid] = { itemid: value.itemid, itemquantity: 0, itemweight: 0, itemvolume: 0 };
          result.push(res[value.itemid])
        }
        res[value.itemid].itemquantity += value.itemquantity;
        res[value.itemid].itemweight += value.itemweight;
        res[value.itemid].itemvolume += value.itemvolume;
        return res;
      }, {});
      return result;
    },
    groupBy2(array) {
      var result = [];
      array.reduce(function(res, value) {
        if (!res[value.itemid]) {
          res[value.itemid] = { itemid: value.itemid, itemquantity: 0, weight: 0, volume: 0 };
          result.push(res[value.itemid])
        }
        res[value.itemid].itemquantity += value.unloadQty;
        res[value.itemid].itemweight += value.unloadWgt;
        res[value.itemid].itemvolume += value.unloadVol;
        return res;
      }, {});
      return result;
    },
    getCompanySetting(code, name){
      if(this.data_company==null) return '';
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    getLoadingList(){
      if(this.transactions==null) return [];
      let trans = this.transactions.filter(trans=>trans.transtype=='Loading');
      if(trans.length==0) return [];
      let group = this.groupBy(trans);
      return group;
    },
    getUnloadingList(){
      if(this.transactions==null) return [];
      let trans = this.transactions.filter(trans=>trans.transtype=='Unloading');
      console.log('unloading', trans)
      if(trans.length==0) return [];
      let group = this.groupBy2(trans);
      return group;
    },
    getQuantity(itemid, qty){
      if(this.data_company==null) return 0;
      let item = this.data_company.items.find((x) => x._id == itemid);
      if(item==null) return 0;
      let pieces = qty % 1;
      let itemquantity = (qty - pieces);
      return Math.round(itemquantity);          
    },
    getPieces(itemid, qty){
      if(this.data_company==null) return 0;
      let item = this.data_company.items.find((x) => x._id == itemid);
      if(item==null) return 0;
      let pieces = qty % 1;
      let itempieces = (pieces * item.itemconvert);
      return Math.round(itempieces);          
    },
    getSalesQuantity(itemid){
      let sale = this.sales.find(i=>i.itemid==itemid);
      let result = sale!=null ? sale['quantity'] : 0;  
      return result;      
    },
    getBalanceQuanity(itemid){
      let list = this.getLoadingList();
      let find = list.find(x=>x.itemid==itemid);
      let loading_qty = find!=null ? find.itemquantity: 0;
      
      let sale = this.sales.find(i=>i.itemid==itemid);
      let sale_qty = sale!=null ? sale['quantity'] : 0;
      let result = loading_qty - sale_qty;  
      return result;   
    },
    getUnloadingQuantity(itemid){
      let list = this.getUnloadingList();
      let find = list.find(x=>x.itemid==itemid);
      return find!=null ? find.itemquantity: 0;
    },
    getDifferenceQuantity(itemid){
      let unloading_qty = this.getUnloadingQuantity(itemid);
      let balance_qty = this.getBalanceQuanity(itemid);
      let result = unloading_qty - balance_qty;
      return result;
    },
    getBalanceQuanityTotal(){
      let loading = this.getLoadingList();
      let loading_qty = loading.reduce((a, b) => a + b.itemquantity, 0);      
      let sale_qty = this.sales.reduce((a, b) => a + b.quantity, 0);
      let result = loading_qty - sale_qty;  
      return parseFloat(result.toFixed(2));  
    },
    getUnloadingQuantityTotal(){
      let unloading = this.getUnloadingList();
      let unloading_qty = unloading.reduce((a, b) => a + b.itemquantity, 0);    
      return parseFloat(unloading_qty.toFixed(2));
    },
  },
  computed: {
    data_vehicle(){
      if(this.data_company==null) return '';
      if(this.data_company.vehicles==null || this.data_company.vehicles.length==0) return null;
      let vehicle = this.data_company.vehicles.find(i=>i._id == this.initvalue.vehicleid);
      if(vehicle!=null) return vehicle['vehiclename'];
      return '';
    },
    data_location(){
      if(this.data_company==null) return '';
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationcode'];
      return '';
    },
    data_driver(){
      if(this.data_company==null) return '';
      if(this.data_company.users==null || this.data_company.users.length==0) return null;
      let driver = this.data_company.users.find(i=>i._id == this.initvalue.driverid);
      if(driver!=null) return driver['username'];
      return null;
    },
    data_loader(){
      if(this.data_company==null) return '';
      if(this.data_company.users==null || this.data_company.users.length==0) return null;
      let loader = this.data_company.users.find(i=>i._id == this.initvalue.loaderid);
      if(loader!=null) return loader['username'];
      return null;
    }
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getLoadingOrderRequest(this.id);
      this.transactions = Object.assign([], this.initvalue.transactions);
      this.sales = Object.assign([], this.initvalue.sales);
      let images = this.initvalue.images;
      this.load_image = images.find(i=>i.imagename.includes('Load'))??null;
      this.unload_image = images.find(i=>i.imagename.includes('Unload'))??null;
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
    }
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
